import api from './api';
import { unwrapApiResponse } from '@/utils/api-response.util';
import { ClientDashboardData } from '@/types/client-dashboard';
import { ResourceUsageSummary } from '@/types/resource-usage';

export const getClientDashboard = async (clientId: string, days?: number): Promise<ClientDashboardData> => {
  const response = await api.get(`/client-dashboard/${clientId}`, { params: days ? { days } : undefined });
  return unwrapApiResponse<ClientDashboardData>(response.data);
};

/** Той самий блок активності, що в адмінському /admin/resource-usage — окремий лейзі-запит. */
export const getClientResourceUsage = async (clientId: number): Promise<ResourceUsageSummary> => {
  const response = await api.get(`/client-dashboard/${clientId}/resource-usage`);
  return unwrapApiResponse<ResourceUsageSummary>(response.data);
};

/** Активність клієнта для продакт-менеджера - та сама відповідь, що getClientDashboard. */
export const getPmClientDashboard = async (clientId: number, days?: number): Promise<ClientDashboardData> => {
  const response = await api.get(`/pm/clients/${clientId}/dashboard`, { params: days ? { days } : undefined });
  return unwrapApiResponse<ClientDashboardData>(response.data);
};
